// visit tasks
export const GET_VISIT_TASKS_SUCCESS = 'GET_VISIT_TASKS_SUCCESS';
export const GET_VISIT_TASKS_FAILURE = 'GET_VISIT_TASKS_FAILURE';
export const GET_VISIT_TASKS_REQUEST = 'GET_VISIT_TASKS_REQUEST';
export const CLEAR_VISIT_TASKS = 'CLEAR_VISIT_TASKS';

// visit task
export const SELECT_VISIT_TASK = 'SELECT_VISIT_TASK';
export const CLEAR_SELECTED_VISIT_TASK = 'CLEAR_SELECTED_VISIT_TASK';
